import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {Row, Form, Divider, Typography, Checkbox } from 'antd';

import {RTLCol, RTLButton, RTLTable} from '../RTLKit';


/* ------ Field -------- */
import TextField from '../formFields/TextField';
import SelectField from '../formFields/SelectField';


/* ------ Validate / Warn  -------- */
import Loading from "../loading/loading";
import CheckBoxField from "../formFields/CheckBoxField";
import moment from "jalali-moment";
import {Link} from "react-router-dom";

const productColumns = [
    {
        title: 'نام محصول',
        dataIndex: 'product_name',
        width:'70%'
    },
    {
        title: 'قیمت',
        dataIndex: 'price',
        width:'10%'
    },
    {
        title: 'تعداد',
        dataIndex: 'count',
        width:'10%'
    },
    {
        title: 'جمع',
        dataIndex: 'sum',
        width:'10%'
    },
];

const serviceColumns = [
    {
        title: 'نام خدمت',
        dataIndex: 'service_name',
        width:'70%'
    },
    {
        title: 'قیمت',
        dataIndex: 'price',
        width:'10%',
    },
    {
        title: 'تعداد',
        dataIndex: 'count',
        width:'10%'
    },
    {
        title: 'جمع',
        dataIndex: 'sum',
        width:'10%'
    },
];

class AddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            cities:[],
            formLayout: 'horizontal',
            role:this.props.userValue ? this.props.userValue.rl : null,
            replacement:0,
            commuting_price:0,
            operator_price:0,
            operator_description:'',
            approved_guarantee:false,
            totalGuaranteeFee:0,
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        if (this.props.match.params.inquiryId){
            let id = this.props.match.params.inquiryId;
            this.setState({id : id})
            this.props.getItem(id)
        }
    }
    __goBack(){
        this.props.history.goBack()
    }


    __fixProductInfoForShowInTable(){
        let list = []
        if(this.props.initialValues && this.props.initialValues.products)
            list = this.props.initialValues.products
        let products = [];

        if (list) {

            for (let i = 0; i < list.length; i++) {

                products.push({
                    key: i,
                    product_name : (list[i].title ? list[i].title : ''),
                    price: list[i].price ? list[i].price.toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : '',
                    count: list[i].count ? list[i].count : '',
                    sum: (list[i].count)*list[i].price,
                });

            }

        }
        return products;
    }

    __fixServiceInfoForShowInTable(){
        let list = []
        if(this.props.initialValues && this.props.initialValues.services)
            list = this.props.initialValues.services

        let services = [];

        if (list) {

            for (let i = 0; i < list.length; i++) {

                services.push({
                    key: i,
                    service_name : (list[i].title ? list[i].title : ''),
                    price: list[i].price ? list[i].price.toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : '',
                    count: list[i].count ? list[i].count : '',
                    sum: (list[i].count)*list[i].price,
                });

            }

        }
        return services;
    }

    onChangeVal(val){
        this.props.onChange(val);
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;
        /*---- set mode ---*/
        const { Text } = Typography;
        if(this.props.initialValues) {
            let commuting_price = 0;
            if(this.state.apply_commuting && this.state.apply_commuting[0] === true)
                commuting_price= this.state.commuting_price
            this.props.initialValues.approved_guarantee = this.state.approved_guarantee
            this.props.initialValues.operator_prices = this.state.operator_price != 0 ? this.state.operator_price : parseInt(this.props.initialValues.system_price)+parseInt(commuting_price)
            this.props.initialValues.totalGuaranteeFee = parseInt(this.props.initialValues.system_price)+parseInt(this.state.commuting_price)
        }

        let cityName;
        let commutingPrice = 0;
        let totalGuaranteeFee = this.props.initialValues ? this.props.initialValues.system_price : 0;

        if(this.props.initialValues && this.props.initialValues.commuting)
            cityName = this.props.initialValues.commuting.title

        if(this.props.initialValues && this.props.initialValues.commuting)
            commutingPrice = this.props.initialValues.commuting.commuting_fee

        if(this.state.apply_commuting && this.state.apply_commuting.length > 0)
            totalGuaranteeFee = parseInt(this.props.initialValues.system_price)+parseInt(this.state.commuting_price)

        return (
            <Form layout={formLayout} approve={this.state.approve} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">استعلام گارانتی سفارشات</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                    : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={15} sm={24} type="flex" justify="start" align="start" >
                        <Row gutter={16}>
                            <div>
                                <RTLCol md={24}>
                                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={productColumns} dataSource={this.__fixProductInfoForShowInTable()} size="small"
                                          footer={this.__fixProductInfoForShowInTable().length > 0 ? pageData => {
                                              let totalSum = 0;
                                              pageData.forEach(({sum}) => {
                                                  totalSum += sum;
                                              })
                                              return (
                                                  <div className="ant-table ant-table-default">
                                                      <table size="small" style={{background:'none'}}>
                                                          <thead className="ant-table-thead">
                                                          <tr className="tableFooter">
                                                              <td colSpan={2} width='90%'>
                                                                  <Text>جمع کلی محصولات گارانتی دار</Text>
                                                              </td>
                                                              <td width='10%'>
                                                                  <Text type="danger">{totalSum.toLocaleString(navigator.language, {minimumFractionDigits: 0})}</Text>
                                                              </td>
                                                          </tr>
                                                          </thead>
                                                      </table>
                                                  </div>
                                              );
                                          } : null}

                                    />
                                </RTLCol>
                            </div>
                            <div>
                                <RTLCol md={24} style={{marginBottom:10}}>
                                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={serviceColumns} dataSource={this.__fixServiceInfoForShowInTable()} size="small"
                                              footer={this.__fixServiceInfoForShowInTable().length > 0 ? pageData => {
                                                  let totalSum = 0;
                                                  pageData.forEach(({sum}) => {
                                                      totalSum += sum;
                                                  })
                                                  return (
                                                      <div className="ant-table ant-table-default">
                                                          <table size="small" style={{background:'none'}}>
                                                              <thead className="ant-table-thead">
                                                              <tr className="tableFooter">
                                                                  <td colSpan={2} width='90%'>
                                                                      <Text>جمع کلی خدمات گارانتی دار</Text>
                                                                  </td>
                                                                  <td width='10%'>
                                                                      <Text type="danger">{totalSum.toLocaleString(navigator.language, {minimumFractionDigits: 0})}</Text>
                                                                  </td>
                                                              </tr>
                                                              </thead>
                                                          </table>
                                                      </div>
                                                  );
                                              } : null}/>
                                </RTLCol>
                            </div>
                            <div style={{marginBottom:10,marginRight:10}}>
                                هزینه ایاب و ذهاب شهر {cityName} : {commutingPrice}
                            </div>
                            <div style={{marginBottom:10}}>
                                <Field
                                    name="apply_commuting"
                                    component={CheckBoxField}
                                    label=""
                                    list={[{label : 'اضافه کردن هزینه ایاب و ذهاب' , value : true}]}
                                    onChange={(val) => this.setState({apply_commuting : val,commuting_price:commutingPrice})}
                                />

                            </div>
                            <div style={{marginBottom:10}}>
                                <RTLCol md={6} sm={24}>
                                    <Checkbox
                                        value={true}
                                        style={{paddingLeft: 10,paddingRight:15}}
                                    />
                                    <span style={{fontWeight:'bold',fontSize:11}}>
                                    اعتبار نهایی گارانتی
                                    </span>
                                </RTLCol>
                                <RTLCol md={8} sm={24}>
                                    <Field
                                        name="operator_price"
                                        component={TextField}
                                        type="text"
                                        defaultValue={this.props.initialValues ? totalGuaranteeFee : 0}
                                        onChange={(val) => this.setState({operator_price : val.target.value})}
                                    />
                                </RTLCol>
                            </div>
                            <div style={{marginBottom:10}}>
                                <RTLCol md={24} sm={24}>
                                    <Field
                                        name="operator_description"
                                        component={TextField}
                                        type="text"
                                        placeholder="توضیحات اپراتور"
                                        onChange={(val) => this.setState({operator_description : val})}
                                    />
                                </RTLCol>
                            </div>
                            <Divider orientation="left">مشخصات محصول گارانتی دار</Divider>
                            <RTLCol md={24}>
                                <label>توضیحات تکنسین : </label>
                                {this.props.initialValues ? this.props.initialValues.technician_description : ''}
                            </RTLCol>
                            {this.props.initialValues && this.props.initialValues.guarantee_table.length > 0 && this.props.initialValues.guarantee_table.map((item, index) => {
                                return(
                                    <div>
                                        <RTLCol md={12}>
                                            <label>نام محصول : </label>
                                            {item.title}
                                        </RTLCol>
                                        <RTLCol md={12}>
                                            <label>کد درخواست : </label>
                                            {this.props.initialValues.order.system_code}
                                        </RTLCol>
                                        <RTLCol md={12}>
                                            <label>قیمت : </label>
                                            {item.price.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
                                        </RTLCol>
                                        <RTLCol md={12}>
                                            <label>پایان گارانتی : </label>
                                            {moment(item.guarantee_finish_date).format('jYYYY/jM/jD')}
                                        </RTLCol>
                                        <RTLCol md={12}>
                                            <label>تعداد استفاده : </label>
                                            {item.used_count}
                                        </RTLCol>
                                        <RTLCol md={12}>
                                            <label>کد گارانتی : </label>
                                            {item.system_code}
                                        </RTLCol>
                                        <Divider />
                                    </div>
                                )
                            })}
                        </Row>
                    </RTLCol>
                </Row>
                <Row>
                    <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" onClick={() => this.setState({approved_guarantee:true})} className="login-form-button">
                        تایید
                    </RTLButton>
                    <RTLButton onClick={() => this.setState({operated_guarantee : false})} className="backBtn" type="default" shape="round" htmlType="submit" onClick={() => this.setState({approved_guarantee:false})}>
                        عدم تایید
                    </RTLButton>
                </Row>
            </Form>

        );
    }

}

export default AddEditForm = reduxForm({
    form: 'applyGuarantee',
})(AddEditForm)
